var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lab 1",
    clipPath: "url(#clip0_136_2730)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.8906 40.6406C30.4297 36.4219 26.8516 33.1328 22.5078 33.1328C18.1641 33.1328 14.5859 36.4219 14.125 40.6406H30.8906Z",
    fill: "#788D9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5938 38.6719C14.3672 39.2969 14.2031 39.9609 14.1328 40.6406H30.8984C30.8203 39.9531 30.6641 39.2969 30.4375 38.6719H14.5938Z",
    fill: "#445C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.2031 36.2422C16.625 35.7969 13.2266 33.9844 10.8438 30.9219L13.7188 28.6875C17.25 33.2266 23.8125 34.0547 28.3516 30.5234C32.8906 26.9922 33.7188 20.4297 30.1875 15.8906C29.1562 14.5625 27.8672 13.5391 26.3594 12.8359L27.8906 9.53906C29.8984 10.4766 31.6875 11.8984 33.0625 13.6641C37.8203 19.7891 36.7109 28.6484 30.5859 33.4062C27.5156 35.7812 23.7734 36.6875 20.2031 36.2422Z",
    fill: "#788D9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.0859 6.3125L28.1484 2.375C27.8672 2.09375 27.4063 2.09375 27.125 2.375L17.0938 12.4141L22.0547 17.375L32.0859 7.33594C32.375 7.05469 32.375 6.59375 32.0859 6.3125Z",
    fill: "#EFF3F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.0859 6.31244L28.1484 2.37494C27.8828 2.10932 27.4531 2.09369 27.1719 2.33588C27.1875 2.3515 27.2031 2.35932 27.2188 2.37494L31.1562 6.31244C31.4375 6.59369 31.4375 7.05463 31.1562 7.33588L21.5859 16.9062L22.0547 17.3749L32.0859 7.33588C32.375 7.05463 32.375 6.59369 32.0859 6.31244Z",
    fill: "#E3E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.1797 21.3203C23.1094 19.0781 23.0234 15.6953 20.8984 13.5703C18.7734 11.4453 15.3906 11.3515 13.1484 13.289L21.1797 21.3203Z",
    fill: "#DBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.9375 13.5703C21.8984 15.5312 22.125 18.5547 20.6328 20.7734L21.1797 21.3203C23.1094 19.0781 23.0234 15.6953 20.8984 13.5703C19.6641 12.3359 18.0078 11.789 16.3906 11.9297C17.6797 12.039 18.9531 12.5781 19.9375 13.5703Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.8131 15.9573L13.9072 14.0514L11.6257 16.3329L13.5315 18.2388L15.8131 15.9573Z",
    fill: "#EFF3F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.5328 18.2353L11.627 16.3293L11.2071 16.7492L13.1129 18.6551L13.5328 18.2353Z",
    fill: "#788D9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M20.4176 20.5574L18.5117 18.6515L16.2302 20.933L18.136 22.8389L20.4176 20.5574Z",
    fill: "#EFF3F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.817 15.9533L13.9111 14.0474L13.5852 14.3733L15.491 16.2792L15.817 15.9533Z",
    fill: "#E5E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M20.4166 20.559L18.5107 18.6531L18.1848 18.979L20.0906 20.8849L20.4166 20.559Z",
    fill: "#E5E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M18.1373 22.8355L16.2314 20.9296L15.8116 21.3494L17.7174 23.2553L18.1373 22.8355Z",
    fill: "#788D9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M33.5128 3.6571L30.8115 0.955688L28.773 2.99411L31.4744 5.69552L33.5128 3.6571Z",
    fill: "#788D9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M4.03937 24.8984C3.73468 26.4531 4.7503 27.9531 6.29718 28.2578L19.43 30.8281C20.9847 31.1328 22.4847 30.1172 22.7894 28.5625L4.03937 24.8984Z",
    fill: "#FBD984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M12.3672 33.7031C13.9766 33.7031 15.2813 32.3985 15.2813 30.7891C15.2813 29.1797 13.9766 27.875 12.3672 27.875C10.7578 27.875 9.45312 29.1797 9.45312 30.7891C9.45312 32.3985 10.7578 33.7031 12.3672 33.7031Z",
    fill: "#F1786B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M12.3672 32.3047C13.2042 32.3047 13.8828 31.6261 13.8828 30.7891C13.8828 29.952 13.2042 29.2734 12.3672 29.2734C11.5301 29.2734 10.8516 29.952 10.8516 30.7891C10.8516 31.6261 11.5301 32.3047 12.3672 32.3047Z",
    fill: "#EFF3F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M27.6328 15.1719C29.5313 15.1719 31.0703 13.6329 31.0703 11.7344C31.0703 9.8359 29.5313 8.29688 27.6328 8.29688C25.7343 8.29688 24.1953 9.8359 24.1953 11.7344C24.1953 13.6329 25.7343 15.1719 27.6328 15.1719Z",
    fill: "#F1786B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M27.6328 13.5859C28.6554 13.5859 29.4844 12.757 29.4844 11.7344C29.4844 10.7118 28.6554 9.88281 27.6328 9.88281C26.6102 9.88281 25.7812 10.7118 25.7812 11.7344C25.7812 12.757 26.6102 13.5859 27.6328 13.5859Z",
    fill: "#DBDFE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_136_2730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.796875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.5f73f9a46e6e9ffdaa9b405f399a7dfb.svg";
export { ForwardRef as ReactComponent };